/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShiftCreate
 */
export interface ShiftCreate {
    /**
     * 
     * @type {string}
     * @memberof ShiftCreate
     */
    label: string;
}

/**
 * Check if a given object implements the ShiftCreate interface.
 */
export function instanceOfShiftCreate(value: object): value is ShiftCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ShiftCreateFromJSON(json: any): ShiftCreate {
    return ShiftCreateFromJSONTyped(json, false);
}

export function ShiftCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function ShiftCreateToJSON(json: any): ShiftCreate {
    return ShiftCreateToJSONTyped(json, false);
}

export function ShiftCreateToJSONTyped(value?: ShiftCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

